import script from "./terminal-view.vue?vue&type=script&setup=true&lang=ts"
export * from "./terminal-view.vue?vue&type=script&setup=true&lang=ts"

import "./terminal-view.vue?vue&type=style&index=0&id=0701f47f&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0701f47f"]])

export default __exports__